import React, {useCallback, useState} from "react";
import {EXTERNAL_AD_CONFIG} from "../../../apps/website/consts/external-ad-config";
import {AD_DISPLAYS, SESSION_STORAGE_KEYS, VIGNETTE_TYPES} from "../../consts";
import {useEventListener} from "../../../infrastructure/hooks/useEventListener";
import {SessionStorageUtils} from "../../../infrastructure/utils/session-storage.utils";
import {useDisplayAdByLayout} from "../../../infrastructure/hooks/useDisplayAdByLayout";

export const AdInterstitialComposer = (AdInterstitial) => (({controller}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isFilled, setIsAdFilled] = useState(false);
  const {isSmallView} = controller.device;

  const isTestAd = controller.state.appState.settings.config.adDisplay === AD_DISPLAYS.test;
  const baseInterstitialUnit = isSmallView
    ? EXTERNAL_AD_CONFIG.MOBILE.INTERSTITIAL
    : EXTERNAL_AD_CONFIG.DESKTOP.INTERSTITIAL;
  const interstitialUnit = isTestAd ? {...baseInterstitialUnit, adUnit: `${baseInterstitialUnit.adUnit}_test`} : baseInterstitialUnit;


  const sessionStorage = controller.props.ioc.getInstance(SessionStorageUtils);

  const checkFrequencyCap = useCallback(() => {
    const lastShownTime = sessionStorage.get(SESSION_STORAGE_KEYS.lastInterstitialShownTime);

    if (!lastShownTime) {
      return true;
    }

    const timeElapsed: Number = Date.now() - parseInt(lastShownTime, 10);
    const FREQUENCY_CAP_MS: Number = EXTERNAL_AD_CONFIG.CONFIG.INTERSTITIAL_TIME_FREQUENCY_SEC * 1000;

    return timeElapsed >= FREQUENCY_CAP_MS;
  }, []);

  const handlePageTransition = useCallback((event) => {
    const isAnchorClick = event.target.closest('a');

    const {shouldDisplayAd, vignetteType} = useDisplayAdByLayout(controller, interstitialUnit.validLayouts);
    const isBettingPage = controller.state.isBettingPage;

    if (isBettingPage || !shouldDisplayAd || !isAnchorClick || isVisible || !checkFrequencyCap() || vignetteType === VIGNETTE_TYPES.google) {
      return;
    }

    setIsVisible(true);

    window.googletag.pubads()?.addEventListener("slotRenderEnded", (event) => {
      if (event.slot?.getAdUnitPath() === interstitialUnit.adUnit) {
        const isFilled = event.isEmpty === false;
        setIsAdFilled(isFilled);
        setIsVisible(isFilled);
      }
    });

    sessionStorage.set(SESSION_STORAGE_KEYS.lastInterstitialShownTime, Date.now().toString());
  }, [isVisible, checkFrequencyCap]);

  useEventListener('click', handlePageTransition, window);

  const onCloseClick = useCallback(() => {
    setIsVisible(false);
    setIsAdFilled(false);
  }, []);

  let newProps = {
    controller,
    isVisible,
    isFilled,
    onCloseClick,
    unitConfig: interstitialUnit
  };

  return <AdInterstitial {...newProps}/>;
});